<template>
  <div>
    <div class="map__title city-show">
      <span>
        {{ $t('map.naiti-otdelenie-v') }}
        &nbsp;</span>
      <OdpListCitySelect
        :city="city"
        @select="onCitySelect"
      />
    </div>
    <slot name="map-tabs" />
    <div class="map-nav" v-if="showLinkFindOffice">
      <slot name="map-result-odp" />
      <div class="map-nav__button-cont">
        <a class="map-nav__button" :href="href">
          <span class="map-nav__button-text">
            <svg class="filter-icon" width="20px" height="16px">
              <use xlink:href="#filter"></use>
            </svg> Подбор отделения
          </span>
        </a>
        <a
          class="map-nav__button map-nav__button_submenu"
          :class="{ 'map-nav__button_active': showFilter }"
          @click="showFilter = !showFilter"
        >
            <span class="d-flex align-items-center">
              <svg
                class="filter-icon me-3"
                width="16" height="16" viewBox="0 0 16 16"
              >
                <path d="M0.576543 3.36034C-0.192181 2.59162 -0.192181 1.34527 0.576543 0.576543C1.34527 -0.192181 2.59162 -0.192181 3.36034 0.576543L15.4235 12.6397C16.1922 13.4084 16.1922 14.6547 15.4235 15.4235C14.6547 16.1922 13.4084 16.1922 12.6397 15.4235L0.576543 3.36034Z" fill="#ED1651"/>
                <path d="M15.4235 3.36034C16.1922 2.59162 16.1922 1.34527 15.4235 0.576543C14.6548 -0.192181 13.4084 -0.192181 12.6397 0.576543L0.576582 12.6397C-0.192142 13.4084 -0.192142 14.6547 0.576582 15.4235C1.34531 16.1922 2.59165 16.1922 3.36038 15.4235L15.4235 3.36034Z" fill="#ED1651"/>
              </svg>
              Фильтры
            </span>

          <div class="map-nav__submenu">
            <template>
              <div class="map-nav__submenu-item">
                <div class="field-checkbox field-checkbox_switch">
                  <input
                    id="interRefunds"
                    :value="interRefunds"
                    class="field-checkbox__input"
                    type="checkbox"
                    @change="(event) => changeFilters(event)"
                  >
                  <label
                    class="field-checkbox__label"
                    for="interRefunds"
                  >Международные отправления</label>
                </div>
              </div>
            </template>

          </div>

        </a>

      </div>
    </div>
  </div>
</template>

<script>
import { getters as cityGetters } from '../../store/city.store';
import OdpListCitySelect from '../MapWidgetFind/OdpListCitySelect.vue';

export default {
  name: 'FindOdpPanel',
  props: {
    city: Object,
    showLinkFindOffice: {
      type: Boolean,
      default: true,
    },
    absoluteUrl: {
      type: String,
      default: '',
    },
    linkFindOffice: {
      type: String,
      default: '',
    },
    interRefunds: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    showFilter: false,
    queryString: [],
  }),
  components: {
    OdpListCitySelect,
  },
  computed: {
    ...cityGetters,
    encodedUrl() {
      return btoa(encodeURIComponent(JSON.stringify(this.city)));
    },
    href() {
      if (this.linkFindOffice) return this.linkFindOffice;
      return this.$props.absoluteUrl ? `${this.$props.absoluteUrl}find_an_office?cityLocal=${this.encodedUrl}`
        : `/find_an_office?cityLocal=${this.encodedUrl}`;
    },
  },
  methods: {
    onCitySelect(city) {
      this.$emit('select', city);
    },
    changeFilters(e) {
      this.$emit('changeFilters', e);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import './FindOdpPanel.scss';
</style>

<style lang="scss" scoped>

/*.map__frame-cont {
  position: absolute;
  top: 0;
  right: 0;

  @media(max-width: 1050px) {
    position: static;
  }
}
*/

.map {

  &-nav {
    padding: 20px 0;

    &__submenu {

      @media (max-width: 767px) {
        padding-top: 48px;
      }
      &-item {

        &:nth-child(1)::before {
          left: 0;
          right: 0;
        }

        &:nth-child(2)::before {
          left: 30px;
          right: 30px;
        }
      }
    }

    &__text-hidden {
      @media (min-width: 768px) {
        display: none;
        position: absolute;
        visibility: hidden;
      }
    }

    &__button {

      &_active {

        .map-nav__button-text {

          .map-nav__text-hidden {
            display: block;
          }
        }
      }
    }
  }
}

.map__container_up {
  padding-top: 35px;
  position: relative;
  z-index: 99;

  @media (max-width: 767px) {
    margin-bottom: 20px;

    .map-nav {
      padding: 0 !important;
    }

    .formbar-fields {
      margin-left: 0 !important;
      margin-right: 0 !important;
    }
  }
}

.map-nav__button {

  &_submenu {
    min-width: 153px;
    max-width: 153px;
    margin: 0 !important;
    margin-left: 16px !important;

    .map-nav__submenu {
      width: 320px;
      left: -167px;
      top: 100%;
      box-shadow: 0 8px 15px 0 #00000033 !important;
      height: 47px;
    }

    .close-icon {
      position: absolute;
      left: 220px;
      top: -20px;

      @media (max-width: 767px) {
        display: none;
      }
    }

    @media (max-width: 600px) {
      max-width: 320px;
      margin: 0 !important;
      margin-top: 10px !important;
      margin-bottom: 10px !important;

      .map-nav__text-hidden {
        display: block;
      }
    }

    @media (max-width: 580px) {
      max-width: none;

      .map-nav__submenu {
        width: 100%;
        left: 0;
        right: 0;
        top: 100%;
      }
    }

    .filter-icon {
      margin-right: 0;
    }
  }

  &_active {
    @media (min-width: 768px) {
      .map-nav {

        &__button-text {
          top: 30px;
          left: -190px;
        }

        &__text-hidden {
          position: initial;
          min-width: 152px;
          visibility: visible;
        }
      }
    }

    @media (min-width: 601px) {
      .map-nav {

        &__button-text {
          left: -190px;
        }
      }
    }
  }
}

@media (min-width: 1050px) {

  .map__frame-cont {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;

    .map__container {
      height: 100%;

      >>> .map-card {
        right: 20px;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }
}

@media (min-width: 1050px) {

  .map__frame-cont {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;

    .map__container {
      height: 100%;

      >>> .map-card {
        right: 20px;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }
}

.map__title {
  @media(min-width: 768px) {
    text-align: center;
  }
  border: none;
  .city-name {
    display: inline-block;
    vertical-align: baseline;
  }

  .h1 {
    display: inline-block;
    vertical-align: baseline;

    h1, span {
      display: inline-block;
      vertical-align: baseline;
    }

    span {
      white-space: pre;
    }
  }
}
.map-nav__button-text {
  max-width: 228px;
}
.map-nav__button_submenu {
  height: 50px !important;
}
.map-nav__button_active {
  .map-nav__submenu {
    padding: 0;
  }
  &.map-nav__button_submenu {
    box-shadow: 0 8px 15px 0 #00000033;
  }
}
.map-nav__button-cont {
  display: flex;
  justify-content: flex-end;
  @media(max-width: 767px) {
    flex-direction: column;
  }
}
</style>

